module.exports = "<nuc-no-key *ngIf=\"!hasKey && !isLoading\"\n            (onKeyGenerated)=\"onKeyGenerated($event)\" ></nuc-no-key>\n\n<nuc-key *ngIf=\"hasKey && !isLoading\" [activeApiKey]=\"apiKey\" [apiKeys]=\"apiKeys\"\n         (onKeyDelete)=\"onKeyDelete($event)\" (onKeyRegenerate)=\"onKeyRegenerated($event)\"></nuc-key>\n\n\n<nuc-spinner [visible]=\"isLoading\"></nuc-spinner>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/api-key/api-key.component.html
// module id = 1417
// module chunks = 4